import type { FaireProductEntity } from "../../entity_types/product";

export const p_6x786ygzc4: FaireProductEntity = {
  token: "p_6x786ygzc4",
  type: "product",
  name: "Youth Scripture Basketball Crewneck Sweatshirt",
  brandToken: "b_zkxww4gtng",
  brandName: "Chunky Charms",
  imageUrl:
    "https://cdn.faire.com/fastly/b23c14ce893d0ec97f8d53908641541e27259a4015b6dc45bbec365d8e780a9e.png",
  galleryImageUrls: [],
  priceDollars: 14,
  description:
    "Score both style and inspiration with our Youth Scripture Basketball tee from Chunky Charms! This uplifting graphic shirt pairs a bold basketball-inspired design with a meaningful scripture message that encourages confidence, perseverance, and faith — perfect for young athletes who want to express both their love for the game and their values.\n\n🏀 Why customers (and parents) will love it:\n\nSoft, comfortable, kid-friendly fabric for everyday wear\n\nEye-catching sport-themed graphics with an encouraging scripture message that resonates with growing athletes and faith-centered families \n\nMakes a thoughtful gift for youth basketball players, team events, or faith-based youth groups\n\nPerfect for game days, practices, school activity days, or casual weekend wear\n\nThis tee combines athletic energy with an inspiring reminder that faith and perseverance go hand-in-hand — making it a fantastic addition to boutique kids’ apparel collections or Christian gift assortments.",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:32.250Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
